import { SET_LANGUAGE } from '../actions/localization'

const initialState = {
  language: 'DE'
}

export default function setLanguage(state = initialState, action) {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.language
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/localization.js